import gql from 'graphql-tag';

import { useQuery } from '@apollo/react-hooks';

export const getCurrentUserQuery = gql`
  query getCurrentUser {
    currentUserV2 {
      email
      fullName
    }
  }
`;

const useCurrentUser = (): {
  isLoading: boolean;
  user?: {
    email: string;
    fullName: string;
  };
} => {
  const { data, loading } = useQuery<{
    currentUserV2: {
      email: string;
      fullName: string;
    };
  }>(getCurrentUserQuery);

  return {
    isLoading: loading,
    user: data && data.currentUserV2,
  };
};

export default useCurrentUser;
